/**
 * Configuración centralizada de URLs para API y WebSocket
 *
 * Prioridad:
 * 1. Variables de entorno (.env)
 * 2. Auto-detección basada en el dominio actual
 */

// Obtener URL base de la API
export const getApiUrl = () => {
  // Si hay variable de entorno definida, usarla
  if (process.env.REACT_APP_BACKEND_URL) {
    return process.env.REACT_APP_BACKEND_URL;
  }

  // Auto-detectar basado en el dominio actual
  const { protocol, hostname } = window.location;

  // En desarrollo local, asumir puerto 8001
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return `${protocol}//${hostname}:8001`;
  }

  // En producción, asumir mismo dominio con puerto 8001
  // o puedes cambiar esto según tu configuración de servidor
  return `${protocol}//${hostname}:8001`;
};

// Obtener URL de WebSocket
export const getWsUrl = () => {
  // Si hay variable de entorno específica para WS, usarla
  if (process.env.REACT_APP_WS_URL) {
    return process.env.REACT_APP_WS_URL;
  }

  // Derivar de la URL de API
  const apiUrl = getApiUrl();

  if (!apiUrl) {
    // Fallback: usar el host actual
    const wsProtocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
    return `${wsProtocol}//${window.location.host}`;
  }

  try {
    const url = new URL(apiUrl);
    const wsProtocol = url.protocol === 'https:' ? 'wss:' : 'ws:';
    return `${wsProtocol}//${url.host}`;
  } catch (e) {
    // Si la URL no es válida, usar el host actual
    const wsProtocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
    return `${wsProtocol}//${window.location.host}`;
  }
};

// Obtener solo el host para WebSocket (sin protocolo)
export const getWsHost = () => {
  const wsUrl = getWsUrl();
  try {
    return new URL(wsUrl).host;
  } catch (e) {
    return window.location.host;
  }
};

// Exportar constantes para uso directo
export const API_URL = getApiUrl();
export const WS_URL = getWsUrl();
export const WS_HOST = getWsHost();

// Log de configuración en desarrollo
if (process.env.NODE_ENV === 'development') {
  console.log('📡 Config:', { API_URL, WS_URL, WS_HOST });
}

export default {
  API_URL,
  WS_URL,
  WS_HOST,
  getApiUrl,
  getWsUrl,
  getWsHost
};
